import Vue from 'vue';
import userPanel from '@sone/sone-frontend-components/src/components/s1vm/UserPanel.vue';
import authenticatedLayout from '@sone/sone-frontend-components/src/components/s1vm/AuthenticatedLayout.vue';
import userPanelApplications from '@sone/sone-frontend-components/src/components/s1vm/UserPanelApplications.vue';
import userApplications from '@sone/sone-frontend-components/src/components/s1vm/UserApplications.vue';
import userPanelSummary from '@sone/sone-frontend-components/src/components/s1vm/UserPanelSummary.vue';
import userSummary from '@sone/sone-frontend-components/src/components/s1vm/UserSummary.vue';
import userChangePasswordDialog from '@sone/sone-frontend-components/src/components/s1vm/UserChangePasswordDialog.vue';
import soneError from '@sone/sone-frontend-components/src/components/s1vm/SoneError.vue';
import menuItem from '@sone/sone-frontend-components/src/components/s1vm/MenuItem.vue';
import menu from '@sone/sone-frontend-components/src/components/s1vm/Menu.vue';
import shortcutItem from '@sone/sone-frontend-components/src/components/s1vm/ShortcutItem.vue';
import shortcuts from '@sone/sone-frontend-components/src/components/s1vm/Shortcuts.vue';
import applicationsModal from '@sone/sone-frontend-components/src/components/s1vm/ApplicationsModal.vue';
import emptyState from '@sone/sone-frontend-components/src/components/s1vm/EmptyState.vue';
import mezzanine from '@sone/sone-frontend-components/src/components/s1vm/Mezzanine.vue';

export const UserPanel = userPanel;
export const AuthenticatedLayout = authenticatedLayout;
export const UserPanelApplications = userPanelApplications;
export const UserApplications = userApplications;
export const UserPanelSummary = userPanelSummary;
export const UserSummary = userSummary;
export const SoneError = soneError;
export const UserChangePasswordDialog = userChangePasswordDialog;
export const MenuItem = menuItem;
export const Menu = menu;
export const ShortcutItem = shortcutItem;
export const Shortcuts = shortcuts;
export const ApplicationsModal = applicationsModal;
export const EmptyState = emptyState;
export const Mezzanine = mezzanine;

export class S1vm {
    public static register() {
        Vue.component('s1vm-user-panel', userPanel);
        Vue.component('s1vm-user-panel-applications', userPanelApplications);
        Vue.component('s1vm-user-applications', userApplications);
        Vue.component('s1vm-authenticated-layout', authenticatedLayout);
        Vue.component('s1vm-user-panel-summary', userPanelSummary);
        Vue.component('s1vm-user-summary', userSummary);
        Vue.component('s1vm-user-change-password-dialog', userChangePasswordDialog);
        Vue.component('s1vm-sone-error', soneError);
        Vue.component('s1vm-menu-item', menuItem);
        Vue.component('s1vm-menu', menu);
        Vue.component('s1vm-shortcut-item', shortcutItem);
        Vue.component('s1vm-shortcuts', shortcuts);
        Vue.component('s1vm-applications-modal', applicationsModal);
        Vue.component('s1vm-empty-state', emptyState);
        Vue.component('s1vm-mezzanine', mezzanine);
    }
}
